//@ts-check
import React from 'react';

/**
 * @typedef {Object} LoadViewProps
 * @property {string} [className]
 * @property {boolean} [modal]
 * @property {boolean} [loading]
 * @property {string} [loadText]
 * @property {string} [successText]
 */

/**
 * @param {LoadViewProps} props 
 * @returns 
 */
const LoadView = (props) => {
    let className = 'load-view' +
        (props.className == null ? '' : (' ' + props.className)) +
        (props.modal === true ? ' modal' : '') +
        (props.loading === true ? '' : ' success');
    let text = props.loading === true ? props.loadText : props.successText;

    return (
        <div className={className}>
            <div className="image-container">

            </div>
            <span className="lines-placeholder-text">{text}</span>
        </div>
    )
};

export default LoadView;